module.exports = __webpack_public_path__ + "media/images/pc/stores/hamamatsu/hamamatsu_concept_01-6b2b3a64b0bdbb46ad36d865e3845b5d.jpg";